import React from 'react';
import SwatchList from './lists/SwatchList';
import RectangleList from './lists/RectangleList';
import * as pcStyles from './ProductOptions.module.css';
import * as mpsStyles from './ProductOptions.mps.module.scss';
import { storeStyle } from '../../../common/util';

const styles = storeStyle({ mpsStyles, pcStyles });
function ProductOptions({ options, variants, variantSpecs, handleVariantChange, track }) {
  return (
    <div className={styles.productOptions}>
      {options.map(productOption => {
        switch (productOption.type) {
          case 'swatch':
            return (
              <div className={styles.optionContainer} key={`${productOption.id}-swatch`}>
                <SwatchList
                  styles={styles}
                  id={productOption.id}
                  label={productOption.display_name}
                  swatchList={productOption.option_values}
                  variantSpecs={variantSpecs}
                  handleVariantChange={optionValue =>
                    handleVariantChange(productOption.id, optionValue)
                  }
                />
              </div>
            );
          // break;

          default:
            return (
              <div className={styles.optionContainer} key={`${productOption.id}-list`}>
                <RectangleList
                  styles={styles}
                  track={track}
                  id={productOption.id}
                  label={productOption.display_name}
                  rectangleList={productOption.option_values}
                  variantSpecs={variantSpecs}
                  variants={variants}
                  handleVariantChange={optionValue =>
                    handleVariantChange(productOption.id, optionValue)
                  }
                />
              </div>
            );
          // break;
          // break;
        }
      })}
    </div>
  );
}

export default ProductOptions;
